// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".dot[data-v-6439fe1c]{height:10px;width:10px;background-color:red}.dot[data-v-6439fe1c],.parent[data-v-6439fe1c]{border-radius:50%;display:inline-block}.parent[data-v-6439fe1c]{height:30px;width:30px;text-align:center;vertical-align:middle;margin:auto}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
